module.exports = __webpack_public_path__ + "fonts/GothamPro-Bold.woff?a3d7d652af07c3610c453b4a51c788c7";